import React, { useEffect, useState } from 'react';
// import styled from 'styled-components';
import { Badge, Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import 'react-calendar/dist/Calendar.css';
import { FaEdit, FaTimes } from 'react-icons/fa';
import Loading from 'react-loading';
import { api } from './../../services/api';
import { TablePadrão } from './../components/table/index';
import { toast } from 'react-toastify';
import { ModalEditCompany } from '../components/modalEditCompany';
import { ModalAddNotification } from '../components/modalAddNotification';
import { ModalEditNotification } from '../components/modalEditNotification';

interface NotificationTypeEdit {
  id: string;
  titulo: string;
  conteudo: string;
  data_hora: string;
  tipo_notificacao: 'popup' | 'push';
  texto_popup?: string;
  file?: string;
  status: string;
  createdAt: string;
}

interface NotificationType {
  id: string;
  titulo: string;
  conteudo: string;
  data_hora: string; // formato 'YYYY-MM-DD HH:mm'
  tipo_notificacao: 'popup' | 'push' | string;
  texto_popup?: string;
  file?: File | null | string;
  status: string;
}

export function Notify(): React.JSX.Element {
  const [companyDefault, setCompanyDefault] = useState<NotificationType[]>([]);
  const [company, setCompany] = useState<NotificationType[]>([]);
  const [selected, setSelected] = useState<NotificationTypeEdit>();
  const [firstTab, setFirstTab] = useState(true);
  const [secondTab, setSecondTab] = useState(false);
  const [thirdTab, setThirdTab] = useState(false);
  const [fourthTab, setFourthTab] = useState(false);
  const [currentStatus, setCurrentStatus] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenConfirmCancelNotification, setIsOpenConfirmCancelNotification] = useState(false);
  const [selectedNotificationId, setSelectedNotificationId] = useState<{
    id: string;
    data_hora: string;
  } | null>(null);

  const [loading, setLoading] = useState(false);
  const [loadingLocal, setLoadingLocal] = useState(true);

  const [loadingSearch, setLoadingSearch] = useState(false);
  const [septemberDays, setSeptemberDays] = useState<Date[]>([]);
  const [isOpenModalUser, setIsOpenModalUser] = useState(false);
  const [inputNameOrCNPJ, setInputNameOrCNPJ] = useState(null);

  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);

  function handleIsOpenModalUser(): void {
    setIsOpenModalUser(!isOpenModalUser);
  }

  function localUserHandleOpenModal(item: NotificationType): void {
    // @ts-expect-error
    setSelected(item);
    handleIsOpenModalUser();
  }

  const toggleModal = (): void => {
    setIsOpen((prev) => !prev);
  };

  async function findCompaniesPerPage(targetPage: number): Promise<void> {
    setLoading(true);

    try {
      const params = {
        page: targetPage,
        perPage,
        paginated: true,
        ...(inputNameOrCNPJ && { search: String(inputNameOrCNPJ) }),
        ...(currentStatus && { status: currentStatus }),
      };

      const response = await api.get('notifications', { params });

      setCompany(response.data.notifications);
      setCompanyDefault(response.data.notifications);
      setPage(response.data.page);
      setTotalPages(response.data.totalPage);
      setLoading(false);
      setLoadingLocal(false);
    } catch (err) {
      const message = 'Ocorreu um erro ao buscar os dados da empresa';
      setLoading(false);
      toast(message, {
        type: 'error',
      });
    }
  }

  //   useEffect(() => {
  //     findCompaniesPerPage(1)
  //       .then(() => {})
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }, [perPage]);

  // useEffect(() => {
  //   setLoadingLocal(false);
  // }, [tickets]);

  async function filter(): Promise<void> {
    setLoadingLocal(true);

    if (inputNameOrCNPJ?.length === 0) {
      await findCompaniesPerPage(1);
    } else {
      try {
        const params = {
          search: String(inputNameOrCNPJ),
          page,
          perPage,
          paginated: true,
          ...(currentStatus !== '' && { status: currentStatus }),
        };

        const response = await api.get('notifications', { params });

        setCompany(response.data?.notifications);
        setLoadingLocal(false);
        setPage(response.data.page);
        setTotalPages(response.data.totalPage);
      } catch (error) {
        console.log(error);
        setLoadingLocal(false);
      }
    }
  }
  useEffect(() => {
    if (inputNameOrCNPJ !== null) {
      const handler = setTimeout(() => {
        filter().catch((err) => {
          console.log(err);
        });
      }, 500); // debounce de 500ms

      return () => {
        clearTimeout(handler); // limpa timeout anterior se inputNameOrCNPJ mudar rápido
      };
    }
  }, [inputNameOrCNPJ]);

  const thead = ['Título', 'Conteúdo', 'Tipo de envio', 'Status', 'Ações'];
  const headWidth = ['20%', '30%', '20%', '20%', '10%'];

  useEffect(() => {
    if (currentStatus !== null) {
      findCompaniesPerPage(1)
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    }
  }, [currentStatus]);

  useEffect(() => {
    void findCompaniesPerPage(1);
  }, [perPage]);

  async function handleChangeTabs(tabNumber: number): Promise<void> {
    switch (tabNumber) {
      case 1:
        setFirstTab(true);
        setSecondTab(false);
        setThirdTab(false);
        setFourthTab(false);
        setCurrentStatus('');
        break;
      case 2:
        setFirstTab(false);
        setSecondTab(true);
        setThirdTab(false);
        setFourthTab(false);
        setCurrentStatus('Enviado');
        break;
      case 3:
        setFirstTab(false);
        setSecondTab(false);
        setThirdTab(true);
        setFourthTab(false);
        setCurrentStatus('Agendado');
        break;
      case 4:
        setFirstTab(false);
        setSecondTab(false);
        setThirdTab(false);
        setFourthTab(true);
        setCurrentStatus('Cancelado');
        break;

      default:
        break;
    }
  }

  const toggleConfirmCancelNotification = (item?: { id: string; data_hora: string }): void => {
    setIsOpenConfirmCancelNotification(!isOpenConfirmCancelNotification);
    if (item) {
      setSelectedNotificationId(item);
    } else {
      setSelectedNotificationId(null);
    }
  };

  const handleCancelNotification = async (): Promise<void> => {
    if (!selectedNotificationId) return;

    console.log('Cancelando notificação com ID:', selectedNotificationId);
    const formData = new FormData();
    formData.append('status', 'Cancelado');
    formData.append('data_hora', selectedNotificationId.data_hora);
    await api.patch(`/notifications/${selectedNotificationId.id}`, formData);
    toast.success('Notificação cancelada com sucesso!!');
    await findCompaniesPerPage(1);
    setSelectedNotificationId(null);
  };

  // <div style={{ width: '100%', backgroundColor: '#F2F2F2' }}>

  return (
    <div style={{ width: '100%', backgroundColor: '#FFF', minHeight: '90vh' }}>
      {loading ? (
        <div
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 25 }}
        >
          <Loading width={30} color={'#005675'} type={'spin'} />
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: 50,
            marginTop: 40,
            marginRight: 50,
          }}
        >
          <div className="col-sm-4" style={{ display: 'flex', marginBottom: 15, marginTop: 15 }}>
            <h4>Notificações</h4>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div
              style={{
                display: 'flex',
                backgroundColor: firstTab ? '#FFF' : '#F5F5F5',
                border: '1px solid rgba(0, 0, 0, 0.05)',
                width: 100,
                borderBottom: 'none',
                borderTopRightRadius: 8,
                borderTopLeftRadius: 8,
                height: 30,
                justifyContent: 'center',
                alignItems: 'center',
                position: firstTab ? 'relative' : 'static',
                top: 1,
                cursor: 'pointer',
              }}
              onClick={() => {
                void handleChangeTabs(1);
              }}
            >
              <span>Todos</span>
            </div>
            <div
              style={{
                display: 'flex',
                backgroundColor: secondTab ? '#FFF' : '#F5F5F5',
                border: '1px solid rgba(0, 0, 0, 0.05)',
                width: 100,
                borderBottom: 'none',
                borderTopRightRadius: 8,
                borderTopLeftRadius: 8,
                height: 30,
                justifyContent: 'center',
                alignItems: 'center',
                position: secondTab ? 'relative' : 'static',
                top: 1,
                cursor: 'pointer',
              }}
              onClick={() => {
                void handleChangeTabs(2);
              }}
            >
              <span>Enviados</span>
            </div>
            <div
              style={{
                display: 'flex',
                backgroundColor: thirdTab ? '#FFF' : '#F5F5F5',
                border: '1px solid rgba(0, 0, 0, 0.05)',
                width: 100,
                borderBottom: 'none',
                borderTopRightRadius: 8,
                borderTopLeftRadius: 8,
                height: 30,
                justifyContent: 'center',
                alignItems: 'center',
                position: thirdTab ? 'relative' : 'static',
                top: 1,
                cursor: 'pointer',
              }}
              onClick={() => {
                void handleChangeTabs(3);
              }}
            >
              <span>Agendados</span>
            </div>

            <div
              style={{
                display: 'flex',
                backgroundColor: fourthTab ? '#FFF' : '#F5F5F5',
                border: '1px solid rgba(0, 0, 0, 0.05)',
                width: 100,
                borderBottom: 'none',
                borderTopRightRadius: 8,
                borderTopLeftRadius: 8,
                height: 30,
                justifyContent: 'center',
                alignItems: 'center',
                position: fourthTab ? 'relative' : 'static',
                top: 1,
                cursor: 'pointer',
              }}
              onClick={() => {
                void handleChangeTabs(4);
              }}
            >
              <span>Cancelados</span>
            </div>
          </div>

          <div style={{ border: '1px solid rgba(0, 0, 0, 0.05)' }}>
            <div className="d-flex justify-content-between flex-column flex-md-row p-3 gap-4">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 50,
                  flex: 1,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 15,
                    marginTop: 0,
                  }}
                >
                  <span>Mostrar</span>
                  <Input
                    type="select"
                    onChange={(e) => {
                      setPerPage(Number(e.target.value));
                    }}
                    style={{ width: 80, marginRight: 8, marginLeft: 8 }}
                    value={perPage}
                  >
                    <option key={'10'} value={'10'}>
                      10
                    </option>
                    <option key={'20'} value={'20'}>
                      20
                    </option>
                    <option key={'30'} value={'30'}>
                      30
                    </option>
                  </Input>
                  <span>registros</span>
                </div>
                <div
                  className="col-sm-4"
                  style={{
                    display: 'flex',
                    marginBottom: 15,
                    flexDirection: 'column',
                  }}
                >
                  <Input
                    value={inputNameOrCNPJ}
                    onChange={(e) => {
                      // eslint-disable-next-line @typescript-eslint/no-floating-promises
                      setInputNameOrCNPJ(e.target.value);
                    }}
                    placeholder={'Pesquise por título ou conteúdo'}
                  />

                  {/* <p style={{ fontSize: 14, marginTop: 5 }}>{'(Insira pelo menos 4 caracteres)*'}</p> */}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  marginBottom: 15,

                  flexDirection: 'column',
                  alignItems: 'flex-end',
                }}
              >
                <Button
                  style={{ width: 200, fontWeight: 600 }}
                  color="primary"
                  onClick={toggleModal}
                >
                  Criar notificação
                </Button>
              </div>
            </div>
            <br />
            {loadingLocal ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 25,
                }}
              >
                <Loading width={30} color={'#005675'} type={'spin'} />
              </div>
            ) : company?.length === 0 && !loadingLocal ? (
              <div className="c-text-danger d-flex justify-content-center mt-20">
                Nenhuma notificação encontrada.
              </div>
            ) : (
              <TablePadrão
                page={page}
                totalPage={totalPages}
                thead={thead}
                headWidth={headWidth}
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                handleChangePage={findCompaniesPerPage}
              >
                {company?.map((item, i) => (
                  <tr
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      backgroundColor: i % 2 === 0 ? '#F5F9FF' : '#FFF',
                      padding: 10,
                    }}
                    key={item?.id}
                  >
                    <td
                      style={{
                        width: '20%',
                        justifyContent: 'start',
                        textAlign: 'start',
                        marginLeft: 10,
                      }}
                    >
                      {item?.titulo}
                    </td>

                    <td
                      style={{
                        width: '30%',
                        justifyContent: 'start',
                        textAlign: 'start',
                        marginLeft: 10,
                      }}
                    >
                      {item?.conteudo}
                    </td>

                    <td style={{ width: '20%', textAlign: 'center' }}>
                      {item?.tipo_notificacao === 'popup' && (
                        <Badge className="col-sm-5" color="primary">
                          Pop-Up
                        </Badge>
                      )}
                      {item?.tipo_notificacao === 'push' && (
                        <Badge className="col-sm-5" color="info">
                          Push
                        </Badge>
                      )}
                    </td>
                    <td style={{ width: '20%', textAlign: 'center' }}>
                      {item?.status === 'Enviado' && (
                        <Badge className="col-sm-5" color="success">
                          {item?.status}
                        </Badge>
                      )}
                      {item?.status === 'Agendado' && (
                        <Badge className="col-sm-5" color="warning">
                          {item?.status}
                        </Badge>
                      )}
                      {item?.status === 'Cancelado' && (
                        <Badge className="col-sm-5" color="danger">
                          {item?.status}
                        </Badge>
                      )}
                    </td>
                    <td
                      style={{
                        display: 'flex',
                        width: '10%',
                        textAlign: 'center',
                        gap: 10,
                        justifyContent: 'center',
                      }}
                    >
                      <FaEdit
                        color="#0D6EFD"
                        title="Editar notificação"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          localUserHandleOpenModal(item);
                        }}
                      />
                      {item?.status === 'Agendado' && (
                        <FaTimes
                          color="#f94144"
                          title="Cancelar notificação"
                          style={{ cursor: 'pointer' }}
                          onClick={() => toggleConfirmCancelNotification(item)}
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </TablePadrão>
            )}
          </div>
        </div>
      )}
      {isOpen && (
        <ModalAddNotification
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          isOpen={isOpen}
          handleIsOpen={toggleModal}
          getAllNotifications={findCompaniesPerPage}
        />
      )}
      {selected && (
        <ModalEditNotification
          notification={selected}
          getAllNotifications={findCompaniesPerPage}
          // @ts-expect-error
          handleIsOpen={localUserHandleOpenModal}
          isOpen={isOpenModalUser}
        />
      )}
      {isOpenConfirmCancelNotification && (
        <Modal
          isOpen={isOpenConfirmCancelNotification}
          toggle={() => toggleConfirmCancelNotification()}
        >
          <ModalHeader toggle={() => toggleConfirmCancelNotification()}>
            Cancelar notificação
          </ModalHeader>
          <ModalBody>Tem certeza que deseja cancelar essa notificação?</ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              onClick={async () => {
                await handleCancelNotification();
                toggleConfirmCancelNotification();
              }}
            >
              Cancelar notificação
            </Button>
            <Button color="secondary" onClick={() => toggleConfirmCancelNotification()}>
              Voltar
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </div>
  );
}
